import { render, staticRenderFns } from "./section3.vue?vue&type=template&id=5db4c672&scoped=true&"
import script from "./section3.vue?vue&type=script&lang=js&"
export * from "./section3.vue?vue&type=script&lang=js&"
import style0 from "./section3.vue?vue&type=style&index=0&id=5db4c672&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db4c672",
  null
  
)

export default component.exports